import React from 'react';
import { createUseStyles, Text } from '@Sage/hoi-poi-ui';

import styles from './styles';
const useStyles = createUseStyles(styles, 'CopilotSidebarHistory');

const CopilotSidebarHistoryTab = () => {
    const classes = useStyles();
    return (
        <div className={classes.root}>
            <Text type="h4">History</Text>
        </div>
    );
};

export default CopilotSidebarHistoryTab;
